import React, { useContext } from 'react';
import { Stack } from '@hub/stack';
import { Text } from '@hub/text';
import classNames from 'classnames';
import { LinkContext } from '../../../context';
import { CloudinaryImage } from '../../cloudinary-image';
import analyticsUtils from '../../../helpers/analytics-utils';
import trackClickEvent from '../../../helpers/analytics-utils/track-event';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MegaMenuFeaturedItem = _ref => {
  var _feature$link;

  let {
    parentCategory,
    feature
  } = _ref;
  const Link = useContext(LinkContext);
  return /*#__PURE__*/_jsxs(Stack, {
    sx: {
      width: 'size-xl',
      maxHeight: 'size-full',
      display: ['none', null, null, 'initial']
    },
    className: classNames('sc-slot', "sc-slot-".concat(parentCategory)),
    gap: "spacing-sm",
    shouldWrapChildren: false,
    to: feature === null || feature === void 0 ? void 0 : (_feature$link = feature.link) === null || _feature$link === void 0 ? void 0 : _feature$link.url,
    onClick: feature.link ? () => trackClickEvent(analyticsUtils.categories.UNIVERSAL_HEADER, analyticsUtils.actions.UNIVERSAL_HEADER_NAV_LINK_CLICK, "".concat(parentCategory, " - ").concat(feature.title)) : undefined,
    as: feature.link ? Link : 'div',
    "data-id": "tabs_megamenu-featured-item_MegaMenuFeaturedItem_Stack",
    children: [feature.image && /*#__PURE__*/_jsx(CloudinaryImage, {
      ratio: "1",
      imageSetOrImage: {
        type: 'SQUARE',
        url: feature.image.src,
        alt: feature.image.description
      },
      sizes: 214,
      "data-id": "tabs_megamenu-featured-item_MegaMenuFeaturedItem_CloudinaryImage"
    }), /*#__PURE__*/_jsxs(Stack, {
      shouldWrapChildren: false,
      gap: "spacing-sm",
      "data-id": "tabs_megamenu-featured-item_MegaMenuFeaturedItem_Stack_Stack",
      children: [/*#__PURE__*/_jsxs(Stack, {
        shouldWrapChildren: false,
        "data-id": "tabs_megamenu-featured-item_MegaMenuFeaturedItem_Stack_Stack_3",
        children: [feature.title && /*#__PURE__*/_jsx(Text, {
          tone: "strong",
          lineHeight: "base",
          "data-id": "tabs_megamenu-featured-item_MegaMenuFeaturedItem_Text",
          children: feature.title
        }), feature.body && /*#__PURE__*/_jsx(Text, {
          lineHeight: "base",
          "data-id": "tabs_megamenu-featured-item_MegaMenuFeaturedItem_Text_5",
          children: feature.body
        })]
      }), feature.link && /*#__PURE__*/_jsx(Text, {
        lineHeight: "base",
        sx: {
          textDecoration: 'underline'
        },
        "data-id": "tabs_megamenu-featured-item_MegaMenuFeaturedItem_Text_6",
        children: feature.link.label
      })]
    })]
  });
};